import qs from 'qs';

const filterFunc = (prefix, value) => {
    const filter = ['locale', 'currency', 'apply', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid', 'gbraid', 'wbraid'];
    if (filter.includes(prefix)) return;
    return value;
};

export default (search) => {
    const current = qs.parse(search, {ignoreQueryPrefix: true});
    return qs.stringify(
        {
            ...current
        },
        {
            filter: filterFunc,
            addQueryPrefix: true
        }
    );
};